// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"c00e3f0d","453":"350d9f42","455":"618b3a2b","977":"ea1f2420"}[chunkId] + ".chunk.js";
};